// extracted by mini-css-extract-plugin
export default {"header":"group-module___header___ada215c5","title":"group-module___title___ceb8b19a","pagination":"group-module___pagination___f8c1759c"};